// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"id":"church"},"nodeName":"g","children":[{"attributes":{"id":"fill1","fill":"transparent","d":"M17 10V13H21V21H3V13H7V10L12 6.5L17 10Z"},"nodeName":"path","children":[]},{"attributes":{"id":"fill2","fill":"transparent","d":"M14 21V16C14 14.8954 13.1046 14 12 14C10.8954 14 10 14.8954 10 16V21H14Z"},"nodeName":"path","children":[]},{"attributes":{"id":"stroke2","stroke":"currentColor","d":"M14 21V16C14 14.8954 13.1046 14 12 14C10.8954 14 10 14.8954 10 16V21H14Z","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]},{"attributes":{"id":"stroke1","stroke":"currentColor","d":"M17 13H21V21H17M17 13V21M17 13V10L12 6.5M17 21H7M12 6.5L7 10V13M12 6.5V4M7 13H3V21H7M7 13V21M12 2V4M12 4H14M12 4H10","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]}]}]};

@tag('t-icon-church')
export default class ChurchIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'church',
    }
  }
}
